export type TranslationKeys = {
	common: {
		batal: string;
		simpan: string;
		simpanPreferensi: string;
		berhasilDisimpan: string;
		gagalMuat: string;
		gagalSimpan: string;
		berhasil: string;
		kesalahan: string;
		administrator: string;
		pengguna: string;
		wallNoc: string;
	};
	breadcrumb: {
		home: string;
		kinerjaDevisi: string;
		pengaduanLayanan: string;
		jennaAnalytic: string;
		demografi: string;
		keuangan: string;
		bumdes: string;
		sosial: string;
		keamanan: string;
		bantuan: string;
		pengaturan: string;
		umum: string;
		notifikasi: string;
		aksesDanTim: string;
		sinkronisasi: string;
		profile: string;
		edit: string;
	};
	sidebar: {
		cariApaSaja: string;
		perlebarMenu: string;
		beranda: string;
		kinerjaDevisi: string;
		pengaduanLayanan: string;
		analitik: string;
		demografi: string;
		keuangan: string;
		bumdes: string;
		sosial: string;
		keamanan: string;
		bantuan: string;
		pengaturan: string;
		settingsUmum: string;
		settingsNotifikasi: string;
		settingsKeamanan: string;
		settingsAksesTim: string;
		settingsSinkronisasi: string;
	};
	umum: {
		judulTampilan: string;
		judulDashboard: string;
		bahasaAplikasi: string;
		zonaWaktu: string;
		formatTanggal: string;
		refreshOtomatis: string;
		intervalRefresh: string;
		tampilkanGrid: string;
		animasiTransisi: string;
	};
	notifikasi: {
		metodeNotifikasi: string;
		preferensiAlert: string;
		notifikasiPush: string;
		laporanHarian: string;
		alertSistem: string;
		updateKeamanan: string;
		newsletterBulanan: string;
		tresholdMemori: string;
		tresholdCpu: string;
		tresholdDisk: string;
		alertKritis: string;
		aktivitasTim: string;
		komentarMention: string;
		bunyiNotifikasi: string;
	};
	keamanan: {
		autentikasi: string;
		password: string;
		auditLog: string;
		twoFactor: string;
		biometrikLogin: string;
		ipWhitelist: string;
		logAktivitas: string;
		riwayatLogin: string;
		perangkatTerdaftar: string;
		downloadLog: string;
		cctvAktif: string;
		kameraOnline: string;
		laporanKeamanan: string;
		mingguIni: string;
		petaKeamananCctv: string;
		titikLokasiCctv: string;
		kamera: string;
		daftarCctv: string;
		belumAdaDataCctv: string;
		laporanPublik: string;
		belumAdaLaporanKeamanan: string;
	};
	akses: {
		manajemenTim: string;
		hakAkses: string;
		kolaborasi: string;
		undanganAnggota: string;
		kelolaRole: string;
		daftarAnggotaAktif: string;
		administrator: string;
		editor: string;
		viewer: string;
		orang: string;
		anggota: string;
		izinExport: string;
		requireApproval: string;
	};
	dashboard: {
		suratMingguIni: string;
		totalSuratDiajukan: string;
		pengaduanAktif: string;
		baru: string;
		diproses: string;
		ditolak: string;
		layananSelesai: string;
		totalDiselesaikan: string;
		totalPenduduk: string;
		kepalaKeluarga: string;
		kalenderKegiatan: string;
		tidakAdaKegiatan: string;
		realisasiLabel: string;
		anggaranLabel: string;
		status100: string;
		statusBaik: string;
		statusCukup: string;
		statusRendah: string;
		tidakAdaDataApbdes: string;
		statistikSurat: string;
		trendSurat: string;
		tampilkanDetail: string;
		tidakAdaDataSurat: string;
		divisiTeraktif: string;
		kegiatan: string;
		tidakAdaDataDivisi: string;
		tingkatKepuasan: string;
		tingkatKepuasanSubtitle: string;
		sangatPuas: string;
		puas: string;
		cukup: string;
		kurang: string;
	};
	sinkronisasi: {
		judul: string;
		deskripsi: string;
		dataNoc: string;
		websiteDesa: string;
		informasiSumber: string;
		statusTerakhir: string;
		waktuSinkronisasi: string;
		terkoneksi: string;
		belumPernah: string;
		belumPernahDilakukan: string;
		sinkronkanNoc: string;
		sinkronkanDesa: string;
		tidakAdaAkses: string;
		gagalSinkronisasi: string;
		sinkronisasiBerhasil: string;
		responseGagal: string;
		kesalahanSistem: string;
		gagalDemografi: string;
		berhasilDemografi: string;
		kesalahanDemografi: string;
		model: string;
		url: string;
		nocNama: string;
		desaNama: string;
	};
	kinerjaDivisi: {
		statusSelesai: string;
		statusBerjalan: string;
		statusTertunda: string;
		tidakAdaAktivitas: string;
		diskusi: string;
		tidakAdaDiskusi: string;
		jumlahDokumen: string;
		tidakAdaDokumen: string;
		acaraHariIni: string;
		tidakAdaAcara: string;
		progresKegiatan: string;
		divisiTeraktif: string;
		tidakAdaDataDivisi: string;
		progres: string;
	};
	pengaduanLayanan: {
		totalPengaduan: string;
		bulanIni: string;
		baru: string;
		belumDiproses: string;
		diproses: string;
		sedangDitangani: string;
		selesai: string;
		terselesaikan: string;
		ditolak: string;
		tidakDitindaklanjuti: string;
		trenPengaduan: string;
		tidakAdaDataPengaduan: string;
		suratTerbanyak: string;
		pengajuanTerbaru: string;
		tidakAdaPengajuan: string;
		ajuanIdeInovatif: string;
		tidakAdaIde: string;
		detail: string;
		detailIde: string;
		deskripsiIde: string;
		pengusul: string;
		kontakPengusul: string;
		diajukanPada: string;
		kategoriIde: string;
		tidakAdaKontak: string;
		tutupIde: string;
	};
	bumdes: {
		vsBulanLalu: string;
		updatePenjualan: string;
		mingguIni: string;
		bulanIni: string;
		totalPenjualan: string;
		kategoriSuffix: string;
		produkAktif: string;
		totalTransaksi: string;
		transaksiSuffix: string;
		umkmAktif: string;
		beroperasi: string;
		umkmTerdaftar: string;
		totalRegistrasi: string;
		omzet: string;
		omzetBumdes: string;
		umkmTerbanyak: string;
		kategoriPrefix: string;
		top3Produk: string;
		tidakAdaProdukTerlaris: string;
		terjual: string;
		detailPenjualan: string;
		semuaKategori: string;
		semuaUmkm: string;
		produk: string;
		penjualanBulanIni: string;
		bulanLalu: string;
		trend: string;
		volume: string;
		stok: string;
		aksi: string;
		stokAman: string;
		stokSedang: string;
		stokRendah: string;
		detail: string;
		detailProduk: string;
		perubahan: string;
		statusStok: string;
		perbandinganPenjualan: string;
		tutupDetail: string;
		infoVolume: string;
	};
	keuanganAnggaran: {
		totalApbdes: string;
		tahun: string;
		realisasi: string;
		dari: string;
		pemasukan: string;
		totalRealisasi: string;
		pengeluaran: string;
		jan: string;
		feb: string;
		mar: string;
		apr: string;
		mei: string;
		jun: string;
		jul: string;
		agu: string;
		sep: string;
		okt: string;
		nov: string;
		des: string;
		pemasukanDanPengeluaran: string;
		alokasiAnggaran: string;
		jumlah: string;
		laporanApbdes: string;
		pendapatan: string;
		belanja: string;
		total: string;
		saldo: string;
		totalAnggaran: string;
		realisasiLaporan: string;
		saldoAnggaran: string;
		saldoRealisasi: string;
		danaBantuan: string;
		cair: string;
		proses: string;
		tidakAdaBantuan: string;
	};
	demografiPekerjaan: {
		totalPenduduk: string;
		aktifTerdaftar: string;
		kepalaKeluarga: string;
		totalKk: string;
		kelahiran: string;
		tahunIni: string;
		kemiskinan: string;
		keluargaPrasejahtera: string;
		kematian: string;
		pindahMasuk: string;
		pindahKeluar: string;
		pertumbuhanAlami: string;
		pertumbuhanAlamiKeterangan: string;
		migrasiBersih: string;
		migrasiBersihKeterangan: string;
		perubahanTotal: string;
		pengelompokanUmur: string;
		demografiPekerjaan: string;
		dinamikaPenduduk: string;
		distribusiAgama: string;
		dataPerBanjar: string;
		sektorUnggulan: string;
		banjar: string;
		penduduk: string;
		kk: string;
		miskin: string;
	};
	jennaAnalytic: {
		interaksiHariIni: string;
		plusDariKemarin: string;
		jawabanOtomatis: string;
		dari61Interaksi: string;
		belumDitindak: string;
		perluResponManual: string;
		waktuRespon: string;
		rataRata: string;
		sen: string;
		sel: string;
		rab: string;
		kam: string;
		jum: string;
		sab: string;
		min: string;
		topikKtp: string;
		topikKk: string;
		topikPosyandu: string;
		topikJalan: string;
		topikBansos: string;
		pagiJam: string;
		siangJam: string;
		soreJam: string;
		malamJam: string;
		interaksiChatbot: string;
		topikPertanyaan: string;
		jamTersibuk: string;
	};
	sosial: {
		ibuHamilAktif: string;
		aktif: string;
		balitaTerdaftar: string;
		terdaftar: string;
		alertStunting: string;
		perhatian: string;
		posyanduAktif: string;
		statistikKesehatan: string;
		imunisasiLengkap: string;
		pemeriksaanRutin: string;
		giziBaik: string;
		targetStunting: string;
		jadwalPosyandu: string;
		pendidikan: string;
		jumlahLembagaPendidikan: string;
		jumlahTenagaPengajar: string;
		kesejahteraanMasyarakat: string;
		kesejahteraanKosong: string;
		beasiswaDesa: string;
		penerima: string;
		danaTersalurkan: string;
		tahunAjaran: string;
		lakiLaki: string;
		perempuan: string;
		periode: string;
		kalenderEventBudaya: string;
		eventBudaya1Nama: string;
		eventBudaya1Tanggal: string;
		eventBudaya1Lokasi: string;
		eventBudaya2Nama: string;
		eventBudaya2Tanggal: string;
		eventBudaya2Lokasi: string;
		eventBudaya3Nama: string;
		eventBudaya3Tanggal: string;
		eventBudaya3Lokasi: string;
	};
	help: {
		pusatBantuan: string;
		subtitle: string;
		artikelPanduan: string;
		videoTutorial: string;
		supportAktif: string;
		panduanMemulai: string;
		faq: string;
		hubungiSupport: string;
		dokumentasi: string;
		emailLabel: string;
		whatsappLabel: string;
		jamKerjaLabel: string;
		waktuResponLabel: string;
		tutup: string;
		durasi: string;
		panduanBadge: string;
		guideCaraLoginTitle: string;
		guideCaraLoginDesc: string;
		guideCaraLoginContent: string;
		guideNavTitle: string;
		guideNavDesc: string;
		guideNavContent: string;
		guideFiturTitle: string;
		guideFiturDesc: string;
		guideFiturContent: string;
		guideTipsTitle: string;
		guideTipsDesc: string;
		guideTipsContent: string;
		videoDashboardTitle: string;
		videoAnalisisTitle: string;
		videoLaporanTitle: string;
		videoExportTitle: string;
		faqQ1: string;
		faqA1: string;
		faqQ2: string;
		faqA2: string;
		faqQ3: string;
		faqA3: string;
		faqQ4: string;
		faqA4: string;
		docApiTitle: string;
		docApiDesc: string;
		docIntegrasiTitle: string;
		docIntegrasiDesc: string;
		docFormatTitle: string;
		docFormatDesc: string;
		docBestTitle: string;
		docBestDesc: string;
		jamKerjaValue: string;
		waktuResponValue: string;
		docApiContent: string;
		docIntegrasiContent: string;
		docFormatContent: string;
		docBestContent: string;
		kontakDukungan: string;
		formNama: string;
		formEmail: string;
		formKategori: string;
		formDeskripsi: string;
		formScreenshot: string;
		formScreenshotHint: string;
		kirimTiket: string;
		tiketTerkirim: string;
		tiketGagal: string;
		infoKontak: string;
		jamOperasionalLabel: string;
	};
};

const id: TranslationKeys = {
	common: {
		batal: "Batal",
		simpan: "Simpan Perubahan",
		simpanPreferensi: "Simpan Preferensi",
		berhasilDisimpan: "Preferensi berhasil disimpan",
		gagalMuat: "Gagal memuat preferensi",
		gagalSimpan: "Gagal menyimpan preferensi",
		berhasil: "Berhasil",
		kesalahan: "Kesalahan",
		administrator: "Administrator",
		pengguna: "Pengguna",
		wallNoc: "Wall NOC",
	},
	breadcrumb: {
		home: "Desa Darmasaba",
		kinerjaDevisi: "Kinerja Divisi",
		pengaduanLayanan: "Pengaduan & Layanan Publik",
		jennaAnalytic: "Jenna Analytic",
		demografi: "Demografi & Kependudukan",
		keuangan: "Keuangan & Anggaran",
		bumdes: "Bumdes & UMKM",
		sosial: "Sosial",
		keamanan: "Keamanan",
		bantuan: "Bantuan",
		pengaturan: "Pengaturan",
		umum: "Umum",
		notifikasi: "Notifikasi",
		aksesDanTim: "Akses & Tim",
		sinkronisasi: "Sinkronisasi NOC",
		profile: "Profil",
		edit: "Edit",
	},
	sidebar: {
		cariApaSaja: "cari apa saja",
		perlebarMenu: "Perlebar menu",
		beranda: "Beranda",
		kinerjaDevisi: "Kinerja Divisi",
		pengaduanLayanan: "Pengaduan & Layanan Publik",
		analitik: "Jenna Analytic",
		demografi: "Demografi & Kependudukan",
		keuangan: "Keuangan & Anggaran",
		bumdes: "Bumdes & UMKM Desa",
		sosial: "Sosial",
		keamanan: "Keamanan",
		bantuan: "Bantuan",
		pengaturan: "Pengaturan",
		settingsUmum: "Umum",
		settingsNotifikasi: "Notifikasi",
		settingsKeamanan: "Keamanan",
		settingsAksesTim: "Akses & Tim",
		settingsSinkronisasi: "Sinkronisasi NOC",
	},
	umum: {
		judulTampilan: "Preferensi Tampilan",
		judulDashboard: "Dashboard",
		bahasaAplikasi: "Bahasa Aplikasi",
		zonaWaktu: "Zona Waktu",
		formatTanggal: "Format Tanggal",
		refreshOtomatis: "Refresh Otomatis",
		intervalRefresh: "Interval Refresh",
		tampilkanGrid: "Tampilkan Grid",
		animasiTransisi: "Animasi Transisi",
	},
	notifikasi: {
		metodeNotifikasi: "Metode Notifikasi",
		preferensiAlert: "Preferensi Alert",
		notifikasiPush: "Notifikasi Push",
		laporanHarian: "Laporan Harian",
		alertSistem: "Alert Sistem",
		updateKeamanan: "Update Keamanan",
		newsletterBulanan: "Newsletter Bulanan",
		tresholdMemori: "Treshold Memori",
		tresholdCpu: "Treshold CPU",
		tresholdDisk: "Treshold Disk",
		alertKritis: "Alert Kritis",
		aktivitasTim: "Aktivitas Tim",
		komentarMention: "Komentar & Mention",
		bunyiNotifikasi: "Bunyi Notifikasi",
	},
	keamanan: {
		autentikasi: "Autentikasi",
		password: "Password",
		auditLog: "Audit & Log",
		twoFactor: "Two-Factor Authentication",
		biometrikLogin: "Biometrik Login",
		ipWhitelist: "IP Whitelist",
		logAktivitas: "Log Aktivitas",
		riwayatLogin: "Riwayat Login",
		perangkatTerdaftar: "Perangkat Terdaftar",
		downloadLog: "Download Log",
		cctvAktif: "CCTV Aktif",
		kameraOnline: "Kamera Online",
		laporanKeamanan: "Laporan Keamanan",
		mingguIni: "Minggu ini",
		petaKeamananCctv: "Peta Keamanan CCTV",
		titikLokasiCctv: "Titik Lokasi CCTV",
		kamera: "kamera",
		daftarCctv: "Daftar CCTV",
		belumAdaDataCctv: "Belum ada data CCTV",
		laporanPublik: "Laporan Publik",
		belumAdaLaporanKeamanan: "Belum ada laporan keamanan",
	},
	akses: {
		manajemenTim: "Manajemen Tim",
		hakAkses: "Hak Akses",
		kolaborasi: "Kolaborasi",
		undanganAnggota: "Undangan Anggota Baru",
		kelolaRole: "Kelola Role & Permission",
		daftarAnggotaAktif: "Daftar Anggota Teraktif",
		administrator: "Administrator",
		editor: "Editor",
		viewer: "Viewer",
		orang: "Orang",
		anggota: "Anggota",
		izinExport: "Izin Export Data",
		requireApproval: "Require Approval Untuk Perubahan",
	},
	dashboard: {
		suratMingguIni: "Surat Minggu Ini",
		totalSuratDiajukan: "Total surat diajukan",
		pengaduanAktif: "Pengaduan Aktif",
		baru: "baru",
		diproses: "diproses",
		ditolak: "Ditolak",
		layananSelesai: "Layanan Selesai",
		totalDiselesaikan: "Total diselesaikan",
		totalPenduduk: "Total Penduduk",
		kepalaKeluarga: "Kepala Keluarga",
		kalenderKegiatan: "Kalender & Kegiatan Mendatang",
		tidakAdaKegiatan: "Tidak ada kegiatan mendatang",
		realisasiLabel: "Realisasi",
		anggaranLabel: "Anggaran",
		status100: "Realisasi mencapai 100% dari anggaran",
		statusBaik: "Realisasi baik, mendekati target",
		statusCukup: "Realisasi cukup, perlu ditingkatkan",
		statusRendah: "Realisasi rendah, perlu perhatian khusus",
		tidakAdaDataApbdes: "Tidak ada data APBDes",
		statistikSurat: "Statistik Pengajuan Surat",
		trendSurat: "Trend pengajuan surat 6 bulan terakhir",
		tampilkanDetail: "Tampilkan Detail",
		tidakAdaDataSurat: "Tidak ada data pengajuan surat 6 bulan terakhir",
		divisiTeraktif: "Divisi Teraktif",
		kegiatan: "Kegiatan",
		tidakAdaDataDivisi: "Tidak ada data divisi",
		tingkatKepuasan: "Tingkat Kepuasan",
		tingkatKepuasanSubtitle: "Tingkat kepuasan layanan",
		sangatPuas: "Sangat Puas",
		puas: "Puas",
		cukup: "Cukup",
		kurang: "Kurang",
	},
	sinkronisasi: {
		judul: "Sinkronisasi Data",
		deskripsi:
			"Gunakan fitur ini untuk memperbarui data dashboard dengan data terbaru dari server sumber.",
		dataNoc: "Data NOC (muku.id)",
		websiteDesa: "Website Desa (darmasaba.desa.id)",
		informasiSumber: "Informasi Sumber Data",
		statusTerakhir: "Status Terakhir",
		waktuSinkronisasi: "Waktu Sinkronisasi Terakhir:",
		terkoneksi: "Terkoneksi",
		belumPernah: "Belum Pernah Sinkron",
		belumPernahDilakukan: "Belum pernah dilakukan",
		sinkronkanNoc: "Sinkronkan NOC",
		sinkronkanDesa: "Sinkronkan Website Desa",
		tidakAdaAkses:
			"Anda tidak memiliki akses. Pastikan Anda login sebagai admin.",
		gagalSinkronisasi:
			"Gagal melakukan sinkronisasi. Periksa console untuk detail.",
		sinkronisasiBerhasil: "Sinkronisasi berhasil dilakukan",
		responseGagal: "Response tidak dikenali dari server",
		kesalahanSistem:
			"Terjadi kesalahan sistem saat sinkronisasi. Periksa console untuk detail.",
		gagalDemografi: "Gagal melakukan sinkronisasi data demografi.",
		berhasilDemografi: "Sinkronisasi data demografi berhasil",
		kesalahanDemografi:
			"Terjadi kesalahan sistem saat sinkronisasi data demografi.",
		model: "Model:",
		url: "URL:",
		nocNama: "Network Operation Center (NOC)",
		desaNama: "Website Desa Darmasaba",
	},
	kinerjaDivisi: {
		statusSelesai: "Selesai",
		statusBerjalan: "Berjalan",
		statusTertunda: "Tertunda",
		tidakAdaAktivitas: "Tidak ada aktivitas terbaru",
		diskusi: "Diskusi",
		tidakAdaDiskusi: "Tidak ada diskusi",
		jumlahDokumen: "Jumlah Dokumen",
		tidakAdaDokumen: "Tidak ada dokumen",
		acaraHariIni: "Acara Hari Ini",
		tidakAdaAcara: "Tidak ada acara hari ini",
		progresKegiatan: "Progres Kegiatan",
		divisiTeraktif: "Divisi Teraktif",
		tidakAdaDataDivisi: "Tidak ada data divisi",
		progres: "Progres",
	},
	pengaduanLayanan: {
		totalPengaduan: "Total Pengaduan",
		bulanIni: "Bulan ini",
		baru: "Baru",
		belumDiproses: "Belum diproses",
		diproses: "Diproses",
		sedangDitangani: "Sedang ditangani",
		selesai: "Selesai",
		terselesaikan: "Terselesaikan",
		ditolak: "Ditolak",
		tidakDitindaklanjuti: "Tidak ditindaklanjuti",
		trenPengaduan: "Tren Pengaduan",
		tidakAdaDataPengaduan: "Tidak ada data pengaduan 7 bulan terakhir",
		suratTerbanyak: "Surat Terbanyak",
		pengajuanTerbaru: "Pengajuan Terbaru",
		tidakAdaPengajuan: "Tidak ada pengajuan terbaru",
		ajuanIdeInovatif: "Musrenbang",
		tidakAdaIde: "Tidak ada ide inovatif",
		detail: "Detail",
		detailIde: "Detail Ide Inovatif",
		deskripsiIde: "Deskripsi Ide",
		pengusul: "Pengusul",
		kontakPengusul: "Kontak",
		diajukanPada: "Diajukan Pada",
		kategoriIde: "Kategori",
		tidakAdaKontak: "Tidak ada kontak",
		tutupIde: "Tutup",
	},
	bumdes: {
		vsBulanLalu: "vs bulan lalu",
		updatePenjualan: "Update Penjualan Produk",
		mingguIni: "Minggu ini",
		bulanIni: "Bulan ini",
		totalPenjualan: "Total Penjualan",
		kategoriSuffix: "kategori",
		produkAktif: "Produk Aktif",
		totalTransaksi: "Total Transaksi",
		transaksiSuffix: "transaksi",
		umkmAktif: "UMKM Aktif",
		beroperasi: "Beroperasi",
		umkmTerdaftar: "UMKM Terdaftar",
		totalRegistrasi: "Total registrasi",
		omzet: "Omzet",
		omzetBumdes: "Omzet BUMDes per bulan",
		umkmTerbanyak: "UMKM Terbanyak",
		kategoriPrefix: "Kategori",
		top3Produk: "Top 3 Produk Terlaris",
		tidakAdaProdukTerlaris: "Belum ada data produk terlaris",
		terjual: "terjual",
		detailPenjualan: "Detail Penjualan Produk",
		semuaKategori: "Semua Kategori",
		semuaUmkm: "Semua UMKM",
		produk: "Produk",
		penjualanBulanIni: "Penjualan Bulan Ini",
		bulanLalu: "Bulan Lalu",
		trend: "Trend",
		volume: "Volume",
		stok: "Stok",
		aksi: "Aksi",
		stokAman: "Aman",
		stokSedang: "Sedang",
		stokRendah: "Rendah",
		detail: "Detail",
		detailProduk: "Detail Produk",
		perubahan: "Perubahan",
		statusStok: "Status Stok",
		perbandinganPenjualan: "Perbandingan Penjualan",
		tutupDetail: "Tutup",
		infoVolume: "Volume Penjualan",
	},
	keuanganAnggaran: {
		totalApbdes: "Total APBDes",
		tahun: "Tahun",
		realisasi: "Realisasi",
		dari: "dari",
		pemasukan: "Pemasukan",
		totalRealisasi: "Total Realisasi",
		pengeluaran: "Pengeluaran",
		jan: "Jan",
		feb: "Feb",
		mar: "Mar",
		apr: "Apr",
		mei: "Mei",
		jun: "Jun",
		jul: "Jul",
		agu: "Agu",
		sep: "Sep",
		okt: "Okt",
		nov: "Nov",
		des: "Des",
		pemasukanDanPengeluaran: "Pemasukan dan Pengeluaran (jt)",
		alokasiAnggaran: "Alokasi Anggaran Per Bidang (jt)",
		jumlah: "Jumlah",
		laporanApbdes: "Laporan APBDes",
		pendapatan: "Pendapatan",
		belanja: "Belanja",
		total: "Total:",
		saldo: "Saldo:",
		totalAnggaran: "Total anggaran:",
		realisasiLaporan: "Realisasi",
		saldoAnggaran: "Saldo anggaran:",
		saldoRealisasi: "Saldo realisasi:",
		danaBantuan: "Dana Bantuan dan Hibah",
		cair: "Cair",
		proses: "Proses",
		tidakAdaBantuan: "Tidak ada data bantuan/hibah ditemukan",
	},
	demografiPekerjaan: {
		totalPenduduk: "Total Penduduk",
		aktifTerdaftar: "Aktif terdaftar",
		kepalaKeluarga: "Kepala Keluarga",
		totalKk: "Total KK",
		kelahiran: "Kelahiran",
		tahunIni: "Tahun ini",
		kemiskinan: "Kemiskinan",
		keluargaPrasejahtera: "Keluarga Prasejahtera",
		kematian: "Kematian",
		pindahMasuk: "Pindah Masuk",
		pindahKeluar: "Pindah Keluar",
		pertumbuhanAlami: "Pertumbuhan alami",
		pertumbuhanAlamiKeterangan: "kelahiran − kematian",
		migrasiBersih: "Migrasi bersih",
		migrasiBersihKeterangan: "pindah masuk − pindah keluar",
		perubahanTotal: "Perubahan total",
		pengelompokanUmur: "Pengelompokan Umur",
		demografiPekerjaan: "Demografi Pekerjaan",
		dinamikaPenduduk: "Dinamika Penduduk",
		distribusiAgama: "Distribusi Agama",
		dataPerBanjar: "Data per Banjar",
		sektorUnggulan: "Sektor Unggulan",
		banjar: "Banjar",
		penduduk: "Penduduk",
		kk: "KK",
		miskin: "Miskin",
	},
	jennaAnalytic: {
		interaksiHariIni: "Interaksi Hari Ini",
		plusDariKemarin: "+15% dari kemarin",
		jawabanOtomatis: "Jawaban Otomatis",
		dari61Interaksi: "53 dari 61 interaksi",
		belumDitindak: "Belum Ditindak",
		perluResponManual: "Perlu respon manual",
		waktuRespon: "Waktu Respon",
		rataRata: "Rata-rata",
		sen: "Sen",
		sel: "Sel",
		rab: "Rab",
		kam: "Kam",
		jum: "Jum",
		sab: "Sab",
		min: "Min",
		topikKtp: "Cara mengurus KTP",
		topikKk: "Syarat Kartu Keluarga",
		topikPosyandu: "Jadwal Posyandu",
		topikJalan: "Pengaduan jalan rusak",
		topikBansos: "Info program bansos",
		pagiJam: "Pagi (08–12)",
		siangJam: "Siang (12–16)",
		soreJam: "Sore (16–20)",
		malamJam: "Malam (20–08)",
		interaksiChatbot: "Interaksi Chatbot",
		topikPertanyaan: "Topik Pertanyaan Terbanyak",
		jamTersibuk: "Jam Tersibuk",
	},
	sosial: {
		ibuHamilAktif: "Ibu Hamil Aktif",
		aktif: "Aktif",
		balitaTerdaftar: "Balita Terdaftar",
		terdaftar: "Terdaftar",
		alertStunting: "Alert Stunting",
		perhatian: "Perhatian",
		posyanduAktif: "Posyandu Aktif",
		statistikKesehatan: "Statistik Kesehatan",
		imunisasiLengkap: "Imunisasi Lengkap",
		pemeriksaanRutin: "Pemeriksaan Rutin",
		giziBaik: "Gizi Baik",
		targetStunting: "Target Stunting",
		jadwalPosyandu: "Jadwal Posyandu",
		pendidikan: "Pendidikan",
		jumlahLembagaPendidikan: "Jumlah Lembaga Pendidikan",
		jumlahTenagaPengajar: "Jumlah Tenaga Pengajar",
		kesejahteraanMasyarakat: "Kesejahteraan Masyarakat",
		kesejahteraanKosong: "Belum ada program kesejahteraan",
		beasiswaDesa: "Beasiswa Desa",
		penerima: "Penerima",
		danaTersalurkan: "Dana Tersalurkan",
		tahunAjaran: "Tahun Ajaran",
		lakiLaki: "Laki-laki",
		perempuan: "Perempuan",
		periode: "Periode",
		kalenderEventBudaya: "Kalender Event Budaya",
		eventBudaya1Nama: "Hari Kesaktian Pancasila",
		eventBudaya1Tanggal: "1 Oktober 2025",
		eventBudaya1Lokasi: "Balai Desa",
		eventBudaya2Nama: "Festival Budaya Desa",
		eventBudaya2Tanggal: "20 Mei 2026",
		eventBudaya2Lokasi: "Lapangan Desa",
		eventBudaya3Nama: "Perayaan HUT Desa",
		eventBudaya3Tanggal: "17 Agustus 2026",
		eventBudaya3Lokasi: "Balai Desa",
	},
	help: {
		pusatBantuan: "Pusat Bantuan",
		subtitle:
			"Temukan jawaban untuk pertanyaan Anda atau hubungi tim support kami",
		artikelPanduan: "Artikel Panduan",
		videoTutorial: "Video Tutorial",
		supportAktif: "Support Aktif",
		panduanMemulai: "Panduan Memulai",
		faq: "FAQ",
		hubungiSupport: "Hubungi Support",
		dokumentasi: "Dokumentasi",
		emailLabel: "Email",
		whatsappLabel: "WhatsApp",
		jamKerjaLabel: "Jam Kerja",
		waktuResponLabel: "Waktu Respon",
		tutup: "Tutup",
		durasi: "Durasi",
		panduanBadge: "Panduan",
		guideCaraLoginTitle: "Cara Login",
		guideCaraLoginDesc: "Langkah-langkah untuk login ke dashboard",
		guideCaraLoginContent: `1. Buka browser dan akses URL dashboard desa.\n2. Masukkan email dan password akun Anda pada form login.\n3. Klik tombol "Masuk" untuk melanjutkan.\n4. Jika berhasil, Anda akan diarahkan ke halaman utama dashboard.\n5. Jika lupa password, klik "Lupa Password" dan ikuti instruksi yang dikirim ke email Anda.`,
		guideNavTitle: "Navigasi Dashboard",
		guideNavDesc: "Penjelasan tentang tata letak dan navigasi",
		guideNavContent:
			"1. Sidebar kiri berisi menu utama: Beranda, Kinerja Divisi, Layanan Publik, Demografi, Keuangan, dan Pengaturan.\n2. Header atas menampilkan nama pengguna, notifikasi, dan tombol logout.\n3. Area utama (konten tengah) menampilkan data sesuai menu yang dipilih.\n4. Gunakan breadcrumb di atas konten untuk mengetahui posisi halaman Anda.\n5. Pada perangkat mobile, sidebar dapat dibuka/tutup via ikon menu (hamburger) di header.",
		guideFiturTitle: "Fitur Dasar",
		guideFiturDesc: "Panduan penggunaan fitur-fitur utama",
		guideFiturContent:
			"1. Beranda: Menampilkan ringkasan statistik desa, aktivitas terbaru, dan grafik utama.\n2. Kinerja Divisi: Pantau kegiatan, dokumen, dan diskusi per divisi.\n3. Layanan Publik: Kelola surat pengaduan dan surat layanan warga.\n4. Demografi: Lihat data penduduk, banjar, kesehatan, dan ketenagakerjaan.\n5. Keuangan & UMKM: Pantau anggaran desa dan daftar UMKM.\n6. Pengaturan: Kelola profil pengguna dan konfigurasi sistem.",
		guideTipsTitle: "Tips & Trik",
		guideTipsDesc: "Tips untuk meningkatkan produktivitas",
		guideTipsContent:
			"1. Gunakan shortcut keyboard untuk navigasi lebih cepat di tabel data.\n2. Filter dan pencarian tersedia di setiap halaman daftar — manfaatkan untuk menemukan data spesifik.\n3. Export data ke CSV/Excel dengan tombol Export di halaman tabel untuk laporan offline.\n4. Aktifkan dark mode di Pengaturan untuk kenyamanan bekerja malam hari.\n5. Refresh data secara manual dengan tombol reload jika data tampak tidak sinkron dengan sistem pusat.\n6. Gunakan fitur Jenna (Virtual Assistant) di halaman ini untuk bantuan cepat.",
		videoDashboardTitle: "Dashboard Overview",
		videoAnalisisTitle: "Analisis Data",
		videoLaporanTitle: "Membuat Laporan",
		videoExportTitle: "Export Data",
		faqQ1: "Bagaimana cara reset password?",
		faqA1: `Anda dapat mereset password melalui halaman login dengan klik "Lupa Password"`,
		faqQ2: "Apakah saya bisa mengakses data offline?",
		faqA2: "Saat ini aplikasi hanya dapat diakses secara online",
		faqQ3: "Berapa lama waktu respon support?",
		faqA3: "Tim support kami biasanya merespon dalam waktu kurang dari 24 jam",
		faqQ4: "Bagaimana cara menambahkan pengguna baru?",
		faqA4:
			"Fitur penambahan pengguna dapat ditemukan di menu Pengaturan > Manajemen Pengguna",
		docApiTitle: "API Reference",
		docApiDesc: "Dokumentasi lengkap untuk integrasi API",
		docIntegrasiTitle: "Integrasi Sistem",
		docIntegrasiDesc: "Cara mengintegrasikan dengan sistem eksternal",
		docFormatTitle: "Format Data",
		docFormatDesc: "Spesifikasi format data yang didukung",
		docBestTitle: "Best Practices",
		docBestDesc: "Praktik terbaik dalam penggunaan platform",
		jamKerjaValue: "Senin - Jumat, 09:00 - 17:00 WIB",
		waktuResponValue: "Rata-rata 2-4 jam kerja",
		docApiContent: `GET /api/demografi/summary\ncurl -H "Authorization: Bearer <token>" \\\n  https://dashboard-desa-plus-stg.wibudev.com/api/demografi/summary\nResponse: {"totalPenduduk": 5234, "lakiLaki": 2617, "perempuan": 2617}\n\nGET /api/complaint/stats\ncurl -H "Authorization: Bearer <token>" \\\n  https://dashboard-desa-plus-stg.wibudev.com/api/complaint/stats\nResponse: {"total": 42, "selesai": 30, "proses": 8, "pending": 4}\n\nGET /api/umkm/summary\ncurl -H "Authorization: Bearer <token>" \\\n  https://dashboard-desa-plus-stg.wibudev.com/api/umkm/summary\nResponse: {"totalUmkm": 87, "aktif": 72, "nonaktif": 15}`,
		docIntegrasiContent: `1. Autentikasi: Gunakan JWT token atau session cookie. Dapatkan token via POST /api/auth/login dengan email & password.\n2. Base URL per environment:\n   - Staging: https://dashboard-desa-plus-stg.wibudev.com/api\n   - Production: https://dashboard-desa-plus.wibudev.com/api\n3. Header wajib:\n   - Content-Type: application/json\n   - Authorization: Bearer <token>\n4. Contoh request dari sistem luar:\n   curl -X POST https://dashboard-desa-plus-stg.wibudev.com/api/complaint \\\n     -H "Content-Type: application/json" \\\n     -H "Authorization: Bearer eyJhbGciOiJIUzI1NiIs..." \\\n     -d '{"title": "Aduan Jalan Rusak", "description": "Jalan di Banjar Kaja berlubang"}'`,
		docFormatContent: `Tanggal    : ISO 8601 (YYYY-MM-DD), contoh: 2026-05-08\nWaktu      : HH:mm:ss WIB, contoh: 14:30:00 WIB\nMata Uang  : IDR tanpa desimal, contoh: 15000000\nKoordinat  : Latitude/Longitude desimal, contoh: -8.12345, 115.12345\nStatus Enum:\n  - AKTIF / NONAKTIF\n  - NORMAL / ALERT / STUNTING`,
		docBestContent: `• Gunakan pagination (?page=&limit=) untuk mengambil data besar\n• Hindari polling interval < 30 detik untuk mengurangi beban server\n• Cache response di client-side untuk data yang jarang berubah\n• Gunakan filter periode (startDate/endDate) untuk query besar\n• Jangan expose API key di frontend — selalu gunakan token dari server`,
		kontakDukungan: "Kontak Dukungan",
		formNama: "Nama Lengkap",
		formEmail: "Email",
		formKategori: "Kategori Masalah",
		formDeskripsi: "Deskripsi Masalah",
		formScreenshot: "Screenshot (opsional)",
		formScreenshotHint: "Maks. 2MB, format PNG/JPG",
		kirimTiket: "Kirim Tiket",
		tiketTerkirim:
			"Tiket berhasil dikirim! Tim kami akan menghubungi Anda segera.",
		tiketGagal: "Gagal mengirim tiket. Coba lagi nanti.",
		infoKontak: "Info Kontak Desa",
		jamOperasionalLabel: "Jam Operasional",
	},
};

export default id;
